import { HttpClient } from '@angular/common/http';
import { AuthenticateService } from './authenticate.service';
import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { ENV, URL_CIDADAO_REGISTROS } from '../../src/util/constants';

@Injectable({
  providedIn: 'root'
})
export class PressaoService {

  constructor(private http: HttpClient, private platfom: Platform, private auth: AuthenticateService) {

  }

  recuperar(): Promise<any> {
    return this.http.get(`${URL_CIDADAO_REGISTROS}rest/pressao`,
      { headers: this.getHeadersToken() }).toPromise().catch((error) => {

        if (ENV === 'DEV') {
          return [
            {
              numeroCartao: null,
              id: 173344,
              dataExame: "2024-01-31",
              paMax: 300,
              paMin: 200,
            },
            {
              numeroCartao: null,
              id: 173343,
              dataExame: "2025-03-31",
              paMax: 120,
              paMin: 1,
            },
          ];
        }
      });
  }

  async excluir(data) {
    return this.http.delete(`${URL_CIDADAO_REGISTROS}rest/pressao/${data.id}`,
      { headers: this.getHeadersToken() }).toPromise().then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  async adicionar(prof) {
    let body;
    body = JSON.stringify({
      'dataExame': prof.dataExame,
      'paMin': prof.paMin,
      'paMax': prof.paMax
    });

    return this.http.post(`${URL_CIDADAO_REGISTROS}rest/pressao`,
      body, { headers: this.getHeadersToken() }).toPromise().then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  async edit(prof) {
    let body = JSON.stringify({
      'id': prof.id,
      'dataExame': prof.dataExame,
      'paMin': prof.paMin,
      'paMax': prof.paMax
    });
    return this.http.put(`${URL_CIDADAO_REGISTROS}rest/pressao`,
      body, { headers: this.getHeadersToken() }).toPromise().then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: this.auth.getAuthorizationToken()
    };
  }

  getHeadersToken() {



    // return {
    //   Authorization: this.auth.getAuthorizationToken(),
    //   'Content-Type': 'application/json'
    // };

    const server = JSON.parse(localStorage.getItem('app_icp_token'));
    const token = this.auth.getAuthorizationToken();
    const httpOptions = {
      'Content-Type': 'application/json',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + token,
    };

    return httpOptions;
  }


  getHeadersJson() {
    return {
      'Content-Type': 'application/json'
    };
  }

}
